import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "./store";
import { majorArcanesData } from "./data/majorArcanes";
import { minorArcanesData } from "./data/minorArcanes";
import type { ICard as TarotCard } from "../tarot/cards/types";
import { validateCardsData } from "../tarot/cards/validateCards";

export type {
  Suit,
  MinorSuit,
  CourtRank,
  ICardUprightMeaning,
  ICardReversedMeaning,
  ICard,
} from "../tarot/cards/types";

export {
  COURT_ORDER,
  COURT_NUMBER,
  NUMBER_COURT,
} from "../tarot/cards/constants";

export interface ICardsGroup {
  title: string;
  cards: TarotCard[];
}

export interface ICardsState {
  majorArcanes: ICardsGroup;
  minorArcanes: ICardsGroup;
}

validateCardsData(
  majorArcanesData,
  minorArcanesData
);

const initialState: ICardsState = {
  majorArcanes: {
    title: "Старшие Арканы",
    cards: majorArcanesData,
  },
  minorArcanes: {
    title: "Младшие Арканы",
    cards: minorArcanesData,
  },
};

export const cardsSlice = createSlice({
  name: "cards",
  initialState,
  reducers: {},
});

export const selectCards = (
  state: RootState
) => state.cards;

export default cardsSlice.reducer;

